import React from "react";
import { EMandateType } from "./Mandate/CreateNewMandate";
export var EInvestmentType;
(function (EInvestmentType) {
    EInvestmentType["SIP"] = "SIP";
    EInvestmentType["LUMPSUM"] = "Lumpsum";
})(EInvestmentType || (EInvestmentType = {}));
// export const failureMsg = {
//   SIP: "Your payment for SIP investment has failed. You can retry the payment from Orderbook"
//   Lumpsum: ""
// }
export const minAmount = {
    sipMin: 500,
    lumsumMin: 5000,
};
export var firstInstallmentConstentEnum;
(function (firstInstallmentConstentEnum) {
    firstInstallmentConstentEnum["NOW"] = "Y";
    firstInstallmentConstentEnum["LATER"] = "N";
})(firstInstallmentConstentEnum || (firstInstallmentConstentEnum = {}));
export const MutualFundInvestment = [
    { title: "SIP", value: EInvestmentType.SIP, rank: 1 },
    { title: "Lumpsum", value: EInvestmentType.LUMPSUM, rank: 2 },
];
export const SipFrequency = [
    { title: "Weekly", value: "Weekly" },
    { title: "Fortnightly", value: "Fortnightly" },
    { title: "Monthly", value: "Monthly" },
    { title: "Quarterly", value: "Quarterly" },
];
export const firstInstallmentConstent = [
    { title: "Now", value: firstInstallmentConstentEnum.NOW, rank: 1 },
    { title: "Later", value: firstInstallmentConstentEnum.LATER, rank: 2 },
];
export const SipFrequencycurrentmonth = [
    { title: "1th", value: "1th" },
    { title: "2nd", value: "2nd" },
    { title: "3rd", value: "3rd" },
    { title: "4th", value: "4th" },
    { title: "5th", value: "5th" },
    { title: "6th", value: "6th" },
    { title: "7th", value: "7th" },
];
export var validityRadioEnum;
(function (validityRadioEnum) {
    validityRadioEnum["UNTIL_CANCELLED"] = "999";
    validityRadioEnum["YEAR_10"] = "120";
    validityRadioEnum["YEAR_8"] = "96";
    validityRadioEnum["YEAR_5"] = "60";
    validityRadioEnum["YEAR_3"] = "36";
    validityRadioEnum["YEAR_2"] = "24";
    validityRadioEnum["YEAR_1"] = "12";
    validityRadioEnum["MONTH_9"] = "9";
    validityRadioEnum["MONTH_6"] = "6";
    validityRadioEnum["CUSTOME"] = "custom";
})(validityRadioEnum || (validityRadioEnum = {}));
export const mandateTypeRadioList = [
    { value: EMandateType.EMANDATE, display: "Digital" },
    { value: EMandateType.PHYSICAL, display: "Physical" }
];
export const validityRadio = [
    { value: validityRadioEnum.UNTIL_CANCELLED, display: "Until Cancelled" },
    { value: validityRadioEnum.YEAR_10, display: "120 (10 Years)" },
    { value: validityRadioEnum.YEAR_8, display: "96 (8 Years)" },
    { value: validityRadioEnum.YEAR_5, display: "60 (5 Years)" },
    { value: validityRadioEnum.YEAR_3, display: "36 (3 Years)" },
    { value: validityRadioEnum.YEAR_2, display: "24 (2 Years)" },
    { value: validityRadioEnum.YEAR_1, display: "12 (1 Years)" },
    { value: validityRadioEnum.MONTH_9, display: "9 (9 Months)" },
    { value: validityRadioEnum.MONTH_6, display: "6 (6 Months)" },
    { value: validityRadioEnum.CUSTOME, display: "Custom" },
];
export const MFInvestment = [{ title: "Lumpsum", value: "Lumpsum", rank: 1 }];
export const MFschemeType = [
    { title: "Regular", value: "Regular" },
    { title: "Direct", value: "Direct" },
];
export const MFReturnOption = [
    { title: "Growth", value: "Growth" },
    { title: "Div Payout", value: "DivPayout" },
    { title: "Div Reinv", value: "Div Reinv" },
];
export const MFDivFrequency = [
    { title: "Yearly", value: "Yearly" },
    { title: "Interim", value: "Interim" },
];
export const subtitleDiffMandate = (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "DMsanR_11_400 txt_secondary-gray" },
        "Primary bank account:",
        React.createElement("span", { className: "Roboto_11_400 txt_blackOne1" }, "HDFC BANK LTD (10923874569283)"))));
export const orderList = [
    { title: "Action", value: "Buy" },
    { title: "Product type", value: "F&O (NRML)" },
    { title: "Order type", value: "Market" },
    { title: "No of Lots", value: "2 (Qty: 100)" },
    { title: "Margin required", value: "14,806.75" },
    { title: "Available", value: "5,000.00" },
];
export const paymentstatusDetails = [
    { title: "Date and Time", value: "09-Jan-23, 23:18:27" },
    { title: "Amount", value: "100.00" },
    { title: "Account No", value: "05xxxxxxxx7" },
    { title: "Bank Name", value: "ICICI Bank Ltd" },
    { title: "UPI ID", value: "1092837465@paytm" },
    { title: "Scheme", value: "Nippon India Liquid Funds (G)" },
    { title: "Type", value: "SIP" },
    { title: "Return Option", value: "Growth" },
    { title: "SIP Type", value: "Perpetual" },
    { title: "Frequency", value: "Monthly" },
    { title: "Duration", value: "999" },
    { title: "SIP Date", value: "10-Jan-23" },
    { title: "Mandate ID", value: "130024556" },
    { title: "Order ID", value: "675467" },
];
export const Foliodropdown = [
    {
        title: "10923874-HDFC BANK LTD- N",
        value: "10923874-HDFC BANK LTD- N ...",
    },
    {
        title: "10923874-HDFC BANK LTD- N ...",
        value: "10923874-HDFC BANK LTD- N ...",
    },
];
export const RedemptionMode = [
    { title: "Partial", value: "Partial", rank: 1 },
    { title: "Full", value: "Full", rank: 2 },
];
export const RedemptionBy = [
    { title: "Units", value: "Units", rank: 1, disabled: false },
    { title: "Amount", value: "Amount", rank: 2, disabled: false },
];
export const notelist = [
    {
        listcontent: (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "To cancel the transaction, kindly go to your UPI app, and reject the transaction request."))),
    },
    {
        listcontent: (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                "Get in touch",
                " ",
                React.createElement("span", { className: "txt-midnight-blue txt-underline" }, "1800 - 102 - 3335"),
                " ",
                "(8 AM - 5:30 PM)"))),
    },
    {
        listcontent: (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                "Email",
                React.createElement("span", { className: "txt-midnight-blue txt-underline ps-1" }, "helpdesk@nuvama.com")))),
    },
];
